import React, { ReactNode } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import "./table.css";
import QuantityInput from "../QuantityInput/QuantityInput";
import { CheckBox } from "@mui/icons-material";
import { Checkbox } from "@mui/material";
import Pagination from "../pagination/Pagination";

interface TitleCell {
  label: string;
  sortable: boolean;
  printable?: boolean;
}

export interface ApiData<T> {
  category: string | number;
  count: number;
  page: number;
  total_pages: number;
  total?: number | null | undefined | any;
  data: T[];
}

interface MTableCellProps {
  label: ReactNode;
  isTitle: boolean;

  clickable?: boolean;
  onClick?: (() => void) | null;
}

export function MTableCell({
  label,
  isTitle,
  clickable = false,
  onClick = null,
}: MTableCellProps) {
  return (
    <TableCell
      align="left"
      sx={{
        color: clickable ? "#0B63F8" : "#000",
        fontFamily: isTitle ? "Lato" : "Poppins",
        fontSize: "16px",
        fontStyle: "normal",
        fontWeight: isTitle ? 600 : 400,
        lineHeight: "normal",
        height: "60px",
        opacity: "0,7",
      }}
    >
      {label}
    </TableCell>
  );
}

export enum ActionType {
  VIEW = "view",
  EDIT = "edit",
  DELETE = "delete",
}
interface MActionsCellProps {
  onClick: (action: ActionType) => void;
}

export function MActionsCell({ onClick }: MActionsCellProps) {
  return (
    <TableCell>
      <div className="icon-wrapper">
        <div
          className="button"
          onClick={() => {
            onClick(ActionType.VIEW);
          }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="26"
            height="26"
            viewBox="0 0 26 26"
            fill="none"
          >
            <path
              d="M14.0833 8.125C14.0833 8.41232 13.9692 8.68787 13.766 8.89103C13.5628 9.09419 13.2873 9.20833 13 9.20833C12.7127 9.20833 12.4371 9.09419 12.2339 8.89103C12.0308 8.68787 11.9166 8.41232 11.9166 8.125C11.9166 7.83768 12.0308 7.56213 12.2339 7.35897C12.4371 7.1558 12.7127 7.04166 13 7.04166C13.2873 7.04166 13.5628 7.1558 13.766 7.35897C13.9692 7.56213 14.0833 7.83768 14.0833 8.125ZM10.8333 12.1875C10.8333 11.972 10.9189 11.7653 11.0713 11.613C11.2237 11.4606 11.4303 11.375 11.6458 11.375H13.2708C13.4863 11.375 13.693 11.4606 13.8453 11.613C13.9977 11.7653 14.0833 11.972 14.0833 12.1875V16.7917H14.8958C15.1113 16.7917 15.318 16.8773 15.4703 17.0296C15.6227 17.182 15.7083 17.3887 15.7083 17.6042C15.7083 17.8197 15.6227 18.0263 15.4703 18.1787C15.318 18.3311 15.1113 18.4167 14.8958 18.4167H11.6458C11.4303 18.4167 11.2237 18.3311 11.0713 18.1787C10.9189 18.0263 10.8333 17.8197 10.8333 17.6042C10.8333 17.3887 10.9189 17.182 11.0713 17.0296C11.2237 16.8773 11.4303 16.7917 11.6458 16.7917H12.4583V13H11.6458C11.4303 13 11.2237 12.9144 11.0713 12.762C10.9189 12.6096 10.8333 12.403 10.8333 12.1875Z"
              fill="#187498"
            />
            <path
              d="M13 1.08334C19.5812 1.08334 24.9166 6.41875 24.9166 13C24.9166 19.5813 19.5812 24.9167 13 24.9167C6.41873 24.9167 1.08331 19.5813 1.08331 13C1.08331 6.41875 6.41873 1.08334 13 1.08334ZM2.70831 13C2.70831 15.7295 3.79261 18.3472 5.72267 20.2773C7.65273 22.2074 10.2705 23.2917 13 23.2917C15.7295 23.2917 18.3472 22.2074 20.2773 20.2773C22.2073 18.3472 23.2916 15.7295 23.2916 13C23.2916 10.2705 22.2073 7.65276 20.2773 5.72269C18.3472 3.79263 15.7295 2.70834 13 2.70834C10.2705 2.70834 7.65273 3.79263 5.72267 5.72269C3.79261 7.65276 2.70831 10.2705 2.70831 13Z"
              fill="#187498"
            />
          </svg>
        </div>
        <div
          className="button"
          onClick={() => {
            onClick(ActionType.EDIT);
          }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="28"
            height="27"
            viewBox="0 0 28 27"
            fill="none"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M25.0308 6.31867C25.1417 6.48691 25.1911 6.68825 25.1707 6.88869C25.1503 7.08913 25.0613 7.27638 24.9188 7.41883L14.1937 18.1428C14.0839 18.2525 13.947 18.331 13.797 18.3703L9.32983 19.537C9.18217 19.5755 9.027 19.5747 8.87972 19.5347C8.73245 19.4948 8.5982 19.417 8.49029 19.309C8.38238 19.2011 8.30457 19.0669 8.26458 18.9196C8.2246 18.7723 8.22382 18.6172 8.26233 18.4695L9.429 14.0035C9.46306 13.8694 9.5273 13.7449 9.61683 13.6395L20.3817 2.88167C20.5457 2.71781 20.7681 2.62577 21 2.62577C21.2319 2.62577 21.4543 2.71781 21.6183 2.88167L24.9188 6.181C24.9607 6.22301 24.9982 6.26913 25.0308 6.31867ZM23.0627 6.79933L21 4.73783L11.0623 14.6755L10.3332 17.4673L13.125 16.7382L23.0627 6.79933Z"
              fill="#36AE7C"
            />
            <path
              d="M22.9145 20.02C23.2334 17.2946 23.3352 14.5482 23.219 11.8067C23.2165 11.7421 23.2273 11.6777 23.2508 11.6174C23.2742 11.5572 23.3099 11.5025 23.3555 11.4567L24.5035 10.3087C24.5349 10.2771 24.5747 10.2553 24.6181 10.2458C24.6616 10.2364 24.7069 10.2397 24.7485 10.2553C24.7902 10.271 24.8264 10.2983 24.8529 10.334C24.8794 10.3698 24.895 10.4124 24.8978 10.4568C25.1139 13.7133 25.0319 16.9827 24.6528 20.2242C24.3775 22.5832 22.4828 24.4323 20.1343 24.6948C16.0572 25.1463 11.9427 25.1463 7.86565 24.6948C5.51832 24.4323 3.62248 22.5832 3.34715 20.2242C2.86345 16.0888 2.86345 11.9112 3.34715 7.77583C3.62248 5.41683 5.51715 3.56767 7.86565 3.30517C10.9601 2.96203 14.0778 2.8789 17.1861 3.05667C17.2306 3.05986 17.2733 3.07574 17.309 3.10241C17.3448 3.12909 17.3721 3.16545 17.3878 3.20719C17.4035 3.24893 17.4069 3.2943 17.3977 3.33792C17.3884 3.38154 17.3668 3.4216 17.3355 3.45333L16.177 4.61067C16.1316 4.65587 16.0775 4.69131 16.0179 4.71478C15.9583 4.73826 15.8945 4.74928 15.8305 4.74717C13.2367 4.65899 10.6399 4.75842 8.06048 5.04467C7.30675 5.12809 6.60314 5.46318 6.06333 5.99579C5.52352 6.52841 5.17902 7.22745 5.08548 7.98C4.61771 11.9797 4.61771 16.0203 5.08548 20.02C5.17902 20.7725 5.52352 21.4716 6.06333 22.0042C6.60314 22.5368 7.30675 22.8719 8.06048 22.9553C11.9747 23.3928 16.0253 23.3928 19.9406 22.9553C20.6944 22.8719 21.398 22.5368 21.9378 22.0042C22.4776 21.4716 22.8209 20.7725 22.9145 20.02Z"
              fill="#36AE7C"
            />
          </svg>
        </div>
        <div
          className="button"
          onClick={() => {
            onClick(ActionType.DELETE);
          }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="28"
            height="28"
            viewBox="0 0 28 28"
            fill="none"
          >
            <path
              d="M11.6667 6.125V6.41667H16.3334V6.125C16.3334 5.50616 16.0875 4.91267 15.6499 4.47509C15.2124 4.0375 14.6189 3.79167 14 3.79167C13.3812 3.79167 12.7877 4.0375 12.3501 4.47509C11.9125 4.91267 11.6667 5.50616 11.6667 6.125ZM10.2084 6.41667V6.125C10.2084 5.11939 10.6078 4.15496 11.3189 3.44389C12.03 2.73281 12.9944 2.33334 14 2.33334C15.0056 2.33334 15.9701 2.73281 16.6811 3.44389C17.3922 4.15496 17.7917 5.11939 17.7917 6.125V6.41667H24.3542C24.5476 6.41667 24.733 6.49349 24.8698 6.63024C25.0065 6.76698 25.0834 6.95245 25.0834 7.14584C25.0834 7.33922 25.0065 7.52469 24.8698 7.66144C24.733 7.79818 24.5476 7.875 24.3542 7.875H22.6526L21.4859 21.791C21.3973 22.8478 20.9149 23.8327 20.1343 24.5505C19.3536 25.2684 18.3318 25.6667 17.2714 25.6667H10.7287C9.6683 25.6666 8.64664 25.2681 7.86615 24.5503C7.08567 23.8325 6.60332 22.8477 6.51469 21.791L5.34802 7.875H3.64585C3.45247 7.875 3.267 7.79818 3.13025 7.66144C2.99351 7.52469 2.91669 7.33922 2.91669 7.14584C2.91669 6.95245 2.99351 6.76698 3.13025 6.63024C3.267 6.49349 3.45247 6.41667 3.64585 6.41667H10.2084ZM7.96777 21.6691C8.02584 22.3614 8.34186 23.0066 8.85322 23.4769C9.36457 23.9472 10.0339 24.2083 10.7287 24.2083H17.2714C17.9662 24.2084 18.6357 23.9474 19.1472 23.4771C19.6587 23.0068 19.9748 22.3615 20.0329 21.6691L21.189 7.875H6.81102L7.96777 21.6691ZM12.5417 11.8125C12.5417 11.7167 12.5228 11.6219 12.4862 11.5335C12.4495 11.445 12.3958 11.3646 12.3281 11.2969C12.2604 11.2292 12.18 11.1755 12.0916 11.1388C12.0031 11.1022 11.9083 11.0833 11.8125 11.0833C11.7168 11.0833 11.6219 11.1022 11.5335 11.1388C11.445 11.1755 11.3646 11.2292 11.2969 11.2969C11.2292 11.3646 11.1755 11.445 11.1389 11.5335C11.1022 11.6219 11.0834 11.7167 11.0834 11.8125V20.2708C11.0834 20.3666 11.1022 20.4614 11.1389 20.5499C11.1755 20.6383 11.2292 20.7187 11.2969 20.7864C11.3646 20.8541 11.445 20.9079 11.5335 20.9445C11.6219 20.9811 11.7168 21 11.8125 21C11.9083 21 12.0031 20.9811 12.0916 20.9445C12.18 20.9079 12.2604 20.8541 12.3281 20.7864C12.3958 20.7187 12.4495 20.6383 12.4862 20.5499C12.5228 20.4614 12.5417 20.3666 12.5417 20.2708V11.8125ZM16.1875 11.0833C16.59 11.0833 16.9167 11.41 16.9167 11.8125V20.2708C16.9167 20.4642 16.8399 20.6497 16.7031 20.7864C16.5664 20.9232 16.3809 21 16.1875 21C15.9941 21 15.8087 20.9232 15.6719 20.7864C15.5352 20.6497 15.4584 20.4642 15.4584 20.2708V11.8125C15.4584 11.41 15.785 11.0833 16.1875 11.0833Z"
              fill="#EB5353"
            />
          </svg>
        </div>
      </div>
    </TableCell>
  );
}

interface MHeaderProps {
  titles: TitleCell[];
  isAllSelected: boolean | null;
  onCheckClick: () => void;
  withActions?: boolean;
}

export function MHeader({
  titles,
  isAllSelected,
  onCheckClick,
  withActions = true,
}: MHeaderProps) {
  return (
    <TableHead>
      <TableRow>
        {isAllSelected !== null && (
          <TableCell>
            <Checkbox
              checked={isAllSelected}
              onChange={(event, bool) => onCheckClick()}
            />
          </TableCell>
        )}
        {titles.map((title) =>
          MTableCell({ label: title.label, isTitle: true })
        )}
        {withActions && <MTableCell label="Actions" isTitle={true} />}
      </TableRow>
    </TableHead>
  );
}
